module.exports = __webpack_public_path__ + "static/img/end.926c685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Glasses/end.jpg
// module id = YBo+
// module chunks = 1